module.exports = __webpack_public_path__ + "static/media/hover.cf790cf7.wav";